<section class="container mt-2">
	<h3>Procuração Eletrônica</h3>
	<p>
		Cidadãos com conta Gov.br com nível de confiabilidade Prata ou Ouro podem
		cadastrar uma procuração digital que permite que outra pessoa (outorgado)
		possa representá-lo (outorgante) ou a sua empresa a utilizar os serviços
		digitais disponíveis no Domicílio Eletrônico do Contribuinte em seu nome.
	</p>
	<div class="acoes">
		<div class="acoes__botoes">
			<button
				class="btn btn-primary"
				(click)="outorgar()"
			>
				Outorgar
			</button>
		</div>
	</div>
	<div class="filtros">
		<div class="filtros__botoes">
			<span class="filtros__label">Filtros: </span>
			<div
				ngbDropdown
				#dropdownSituacao="ngbDropdown"
			>
				<button
					class="btn btn-primary"
					ngbDropdownToggle
				>
					Situação
				</button>
				<div
					class="modal_escuro"
					ngbDropdownMenu
				>
					<div class="margin-dropdown dropdown-tamanho">
						<div class="br-radio">
							<input
								id="valida"
								type="radio"
								name="situacao"
								value="0"
								[(ngModel)]="situacao"
							/>
							<label for="valida">Válida</label>
						</div>
						<div class="br-radio">
							<input
								id="revogada"
								type="radio"
								name="situacao"
								value="1"
								[(ngModel)]="situacao"
							/>
							<label for="revogada">Revogada</label>
						</div>
					</div>
					<button
						class="btn btn-primary btn-filtro"
						[disabled]="!situacao"
						(click)="filtroSituacao(); dropdownSituacao.close()"
					>
						Aplicar
					</button>
				</div>
			</div>
			<div
				ngbDropdown
				#dropDownPeriodo="ngbDropdown"
			>
				<button
					class="btn btn-primary"
					ngbDropdownToggle
				>
					Período Outorga
				</button>
				<div ngbDropdownMenu>
					<div class="titulo">
						<span class="titulo__string">Período</span>
					</div>
					<div
						class="margin-dropdown dropdown-tamanho__datepicker datepicker-flex"
					>
						<dp-day-calendar
							theme="dp-material"
							[(ngModel)]="dataInicio"
							(onSelect)="getDataInicio($event)"
							[displayDate]="estadoDataInicial"
							#dayPicker
						></dp-day-calendar>
						<dp-day-calendar
							theme="dp-material"
							[(ngModel)]="dataFim"
							(onSelect)="getDataFim($event)"
							[displayDate]="estadoDataInicial"
							(minDate)="(dataInicio)"
							#dayPicker
						></dp-day-calendar>
					</div>
					<button
						class="btn btn-primary btn-filtro"
						[disabled]="!dataFim || !dataInicio"
						(click)="filtroSituacao(); dropDownPeriodo.close()"
					>
						Aplicar
					</button>
				</div>
			</div>
			<div
				ngbDropdown
				#dropdownOutorgado="ngbDropdown"
			>
				<button
					class="btn btn-primary"
					ngbDropdownToggle
				>
					Outorgado
				</button>
				<div
					class="modal_escuro"
					ngbDropdownMenu
				>
					<div class="margin-dropdown dropdown-tamanho">
						<div class="br-input">
							<label for="input-medium">Outorgado</label>
							<input
								type="text"
								id="input-medium"
								placeholder="Digite aqui..."
								[(ngModel)]="outorgado"
							/>
						</div>
					</div>
					<button
						class="btn btn-primary btn-filtro"
						[disabled]="!outorgado"
						(click)="filtroSituacao(); dropdownOutorgado.close()"
					>
						Aplicar
					</button>
				</div>
			</div>
			<div
				ngbDropdown
				#dropdownRelacao="ngbDropdown"
			>
				<button
					class="btn btn-primary"
					ngbDropdownToggle
				>
					Relação
				</button>
				<div
					class="modal_escuro"
					ngbDropdownMenu
				>
					<div class="margin-dropdown dropdown-tamanho">
						<select
							class="select"
							[(ngModel)]="relacao"
						>
							<option
								value="null"
								disabled
							>
								Selecione a Relação
							</option>
							<option
								*ngFor="let item of relacoes"
								[ngValue]="item.codTipoProcuracao"
							>
								{{ item.dscTipoProcuracao }}
							</option>
						</select>
					</div>
					<button
						class="btn btn-primary btn-filtro"
						[disabled]="relacao == null || undefined || ''"
						(click)="filtroSituacao(); dropdownRelacao.close()"
					>
						Aplicar
					</button>
				</div>
			</div>
			<button
				class="btn btn-secondary btn-filtro"
				(click)="limparFiltro()"
				*ngIf="filtroAtivo"
			>
				Limpar Filtro
			</button>
		</div>
	</div>
	<div class="tabs ml-4">
		<button
			class="br-tag large"
			(click)="toggleTabProcuracao()"
			[ngClass]="{ 'br-tag__selecionado': procuracoesValidas == true }"
		>
			Assinadas
		</button>
		<button
			class="br-tag large"
			(click)="toggleTabProcuracao()"
			[ngClass]="{
				'br-tag__selecionado-invalido': procuracoesValidas == false
			}"
		>
			Não Assinadas
		</button>
	</div>
	<div class="br-table margin-table">
		<div class="table-header">
			<div class="top-bar">
				<div class="table-title mb-5">Tabela de Procurações</div>
			</div>
		</div>
	</div>
	<div class="table-container">
		<table>
			<thead>
				<tr>
					<th scope="col">Protocolo</th>
					<th scope="col">Situação</th>
					<th scole="col">Tipo de Outorga</th>
					<th scope="col">Data Outorga</th>
					<th scope="col">Data Início Vigência</th>
					<th scope="col">Data da Revogação</th>
					<th scope="col">Data Fim Vigência</th>
					<th scope="col">Outorgante</th>
					<th scope="col">Outorgado</th>
					<th scope="col">Relação</th>
					<th
						*ngIf="procuracoesValidas"
						scope="col"
					>
						Documento
					</th>
					<th
						*ngIf="procuracoesValidas"
						scope="col"
					>
						Ações
					</th>
					<th
						*ngIf="!procuracoesValidas"
						scope="col"
					>
						Assinar
					</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngIf="procuracoes?.length; else semDados">
					<tr *ngFor="let procuracao of procuracoes">
						<td>{{ procuracao?.id }}</td>
						<td *ngIf="procuracoesValidas">
							{{ procuracao?.numeracaoRevogada == 0 ? "Válida" : "Revogada" }}
						</td>
						<td *ngIf="!procuracoesValidas">
							{{ procuracao?.numeracaoRevogada == 1 ? "Revogada" : "Não Assinada" }}
						</td>
						<td>{{ procuracao?.tipoOutorga.descricao }}</td>
						<td>{{ procuracao?.dataOutorga | date : "dd/MM/yyyy" }}</td>
						<td>
							{{
								procuracao?.dataInicio
									? (procuracao.dataInicio | date : "dd/MM/yyyy")
									: "Não Informado"
							}}
						</td>
						<td>
							{{
								procuracao?.dataRevoga
									? (procuracao.dataRevoga | date : "dd/MM/yyyy")
									: "Não Informado"
							}}
						</td>
						<td>
							{{
								procuracao?.dataFim
									? (procuracao.dataFim | date : "dd/MM/yyyy")
									: "Não Informado"
							}}
						</td>
						<td>{{ procuracao?.contribuinte.dscRazaoSocial }}</td>
						<td>{{ procuracao?.outorgado.dscNomeCadastro }}</td>
						<td>{{ procuracao?.tipoProcuracao.dscTipoProcuracao }}</td>
						<td *ngIf="procuracoesValidas">
							<img
								class="image"
								[src]="
									modoEscuro
										? '../../../assets/images/icones/white-file-pdf-regular.svg'
										: '../../../assets/images/icones/file-pdf-regular.svg'
								"
								alt="Baixa PDF"
								title="Baixar Procuração"
								(click)="baixarDocumentoAlfresco(procuracao)"
							/>
						</td>
						<td *ngIf="procuracoesValidas">
							<img
								class="image__revogar"
								[src]="
									modoEscuro
										? '../../../assets/images/icones/white-thumbs-down-regular.svg'
										: '../../../assets/images/icones/thumbs-down-regular.svg'
								"
								alt="Revogar Procuração"
								title="Revogar Procuração"
								(click)="
									procuracao.numeracaoRevogada == 0 && procuracoesValidas
										? revogar(procuracao)
										: ''
								"
								[ngClass]="{
									disabled:
										procuracao.numeracaoRevogada == 1 || !procuracoesValidas
								}"
							/>
						</td>
						<td *ngIf="!procuracoesValidas">
							<img
								class="image__assinar"
								[src]="'../../../assets/images/icones/file-signature-solid.svg'"
								alt="Assinar Procuração"
								title="Assinar Procuração"
								[ngClass]="{ disabled: procuracao.numeracaoRevogada == 1 }"
								(click)="
									procuracao.numeracaoRevogada == 0
										? gerarDocumentoProcuracao(
												contribuinteFormatado.codigo,
												procuracao.id
										  )
										: ''
								"
							/>
						</td>
					</tr>
				</ng-container>
				<ng-template #semDados>
					<tr>
						<td
							colspan="10"
							align="center"
						>
							Sem dados para serem exibidos
						</td>
					</tr>
				</ng-template>
			</tbody>
		</table>
	</div>
	<div class="container-paginacao">
		<button
			class="br-button secondary mt-5 button-first"
			(click)="primeiraPagina()"
			[disabled]="pagina == 1 || pagina == 0"
			[ngClass]="{ disabled: pagina == 1, 'botao-proibido': pagina == 1 }"
		>
			Primeira
		</button>
		<button
			class="br-button secondary mt-5 button-first"
			(click)="paginaAnterior()"
			[disabled]="pagina == 1 || pagina == 0"
			[ngClass]="{ disabled: pagina == 1, 'botao-proibido': pagina == 1 }"
		>
			Anterior
		</button>
		<p class="mt-5">{{ pagina }} de {{ quantidadePaginas }}</p>
		<button
			class="br-button secondary mt-5 button-first"
			(click)="proximaPagina()"
			[disabled]="pagina == quantidadePaginas || quantidadePaginas == 0"
			[ngClass]="{
				disabled: pagina == quantidadePaginas,
				'botao-proibido': pagina == quantidadePaginas
			}"
		>
			Próxima
		</button>
		<button
			class="br-button secondary mt-5 button-first"
			(click)="ultimaPagina()"
			[disabled]="pagina == quantidadePaginas || quantidadePaginas == 0"
			[ngClass]="{
				disabled: pagina == quantidadePaginas,
				'botao-proibido': pagina == quantidadePaginas
			}"
		>
			Última
		</button>
	</div>
<!-- Global loading overlay -->
<div class="carregamento" *ngIf="loading">
	<div class="carregamento__spinner">
		<img src="../../../assets/images/icones/logo-animado.svg" alt="Loading..." />
		<span class="carregamento__text">Processing, please wait...</span>
	</div>
</div>
	<div class="div-botao">
		<button
			class="br-button secondary mt-5 mr-4 posicao-botao"
			type="button"
			(click)="scroll()"
			[routerLink]="['/inicio']"
		>
			Retornar
		</button>
	</div>

	<div
		class="backdrop"
		*ngIf="modalDocumento"
	>
		<div class="div br-modal xx-large position-modal">
			<div class="br-modal-header">
				{{ assinaturaAtiva ? "Assinar Procuração" : "Documento da Revogação" }}
				<div
					class="mt-2"
					*ngIf="assinaturaAtiva"
				>
					<span
						>Atenção: Será necessário utilizar o site oficial do Governo
						Digital:
						<a
							href="https://www.gov.br/governodigital/pt-br/assinatura-eletronica"
							target="_blank"
							>Assinatura Eletrônica - Governo Digital (www.gov.br)</a
						>, que exigirá baixar cópia do termo de procuração, assinar no site
						e fazer a carga novamente, sem fechar a janela atual para evitar
						perda de dados.</span
					>
				</div>
			</div>
			<div class="br-modal-body">
				<div class="pdf-container">
					<pdf-viewer
						[src]="docArrayBuffer"
						[rotation]="0"
						[original-size]="false"
						[show-all]="true"
						[fit-to-page]="false"
						[zoom]="0.5"
						[zoom-scale]="'page-width'"
						[stick-to-page]="false"
						[render-text]="true"
						[external-link-target]="'blank'"
						[autoresize]="true"
						[show-borders]="false"
						style="width: 100%; height: 600px"
					>
					</pdf-viewer>
				</div>
				<div class="br-modal-footer justify-content-center">
					<button
						*ngIf="!assinaturaAtiva"
						class="br-button secondary mr-3"
						type="button"
						(click)="fecharModal()"
					>
						Retornar para Procurações
					</button>
					<button
						*ngIf="assinaturaAtiva"
						class="br-button primary"
						type="button"
						(click)="abrirModalDownload()"
					>
						Assinar pelo Governo Digital
					</button>
				</div>
			</div>
		</div>
	</div>

	<div
		class="backdrop"
		*ngIf="modalDownload"
	>
		<div class="div br-modal large position-modal">
			<div class="br-modal-header">Assinatura Digital</div>
			<div class="br-modal-body">
				Será efetuado uma cópia do documento e armazenado em seu computador.
				Localize o documento, abra outra janela do seu navagador e acesso o
				sítio
				<a
					href="https://www.gov.br/governodigital/pt-br/assinatura-eletronica"
					target="_blank"
					>https://www.gov.br/governodigital/pt-br/assinatura-eletronica</a
				>
				e siga as instruções. <strong>Não feche esta janela</strong>
			</div>
			<div class="br-modal-footer justify-content-center">
				<button
					class="br-button secondary mr-4"
					type="button"
					(click)="abrirModalDocumento()"
				>
					Voltar
				</button>
				<button
					class="br-button primary"
					type="button"
					(click)="baixarDocumentoProcuracao()"
				>
					OK
				</button>
			</div>
		</div>
	</div>

	<div
		class="backdrop"
		*ngIf="modalAssinatura"
	>
		<div class="div br-modal large position-modal">
			<div class="br-modal-header">
				Suba o arquivo assinado para formalizar a outorga
			</div>
			<div class="br-modal-footer justify-content-center">
				<div>
					<div class="row justify-content-center">
						<div class="br-upload">
							<input
								class="upload-input"
								type="file"
								multiple="multiple"
								#file
								(change)="getArquivoAssinado($event)"
							/>
							<button
								class="upload-button"
								type="button"
								(click)="file.click()"
							>
								<fa-icon [icon]="['fas', 'upload']"> </fa-icon>
								<span>Selecione o arquivo</span>
							</button>
							<div class="upload-list mt-3 mb-3">
								{{ arquivoAssinado?.name }}
							</div>
						</div>
					</div>
					<div class="row justify-content-center">
						<button
							class="br-button primary mr-4 desistir"
							type="button"
							(click)="desistirAssinatura()"
						>
							Desistir
						</button>
						<button
							class="br-button primary"
							type="button"
							(click)="confirmarAssinatura()"
							[disabled]="!arquivoAssinado"
						>
							Confirmar Outorga
						</button>
					</div>
					<br />
				</div>
			</div>
		</div>
	</div>
</section>
